import { createContext, useContext, ReactNode } from 'react';
import { useToast as useToastHook } from '../hooks/useToast';
import ToastContainer from '../components/shared/ToastContainer';

interface ToastContextType {
  success: (message: string, duration?: number) => void;
  error: (message: string, duration?: number) => void;
  warning: (message: string, duration?: number) => void;
  info: (message: string, duration?: number) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export function ToastProvider({ children }: { children: ReactNode }) {
  const { toasts, success, error, warning, info } = useToastHook();

  return (
    <ToastContext.Provider value={{ success, error, warning, info }}>
      <ToastContainer
        toasts={toasts}
        onClose={() => {
          // onClose is already handled in the Toast component itself
        }}
      />
      {children}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
}
